import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppTheme } from '../../../styles/AppTheme';
import { CommonStyles } from '../../../styles/Styles';
import TableCell from '@material-ui/core/TableCell';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Icon from '@material-ui/core/Icon';

export class TableNumComponentMulti extends Component {
  constructor(props) {
    super(props);
    this.ids = []
  }

  handleCheckbox = (name, id) => event => {
    const index = this.ids.indexOf(name)
    if (index !== -1) {
      this.ids.splice(index, 1);
      this.props.handleState(id, this.ids)
    } else {
      this.ids.push(name)
      this.props.handleState(id, this.ids)
    }
  }

  render() {
    const thisObj = this //TODO
    return (
      Object.keys(this.props.options).sort(function (a, b) { return (Number(thisObj.props.options[a].order) - Number(thisObj.props.options[b].order)) })
        .map((item, index) => {
          return (
            <TableCell className={css(Styles.tableCell)} key={index}>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={this.handleCheckbox(this.props.options[item].id, this.props.id)}
                    value={this.props.options[item].id}
                    color='primary'
                    checkedIcon={
                      <div className={css(Styles.icon)}>
                        <Icon className={css(Styles.checkedIcon)}>done</Icon>
                      </div>
                    }
                    icon={
                      <div className={css(Styles.icon)} />
                    }
                    className={css(CommonStyles.controlLabel)}
                  />
                }
              />
            </TableCell>
          )
        })
    );
  }
}

const Styles = StyleSheet.create({
  icon: {
    width: 30,
    height: 30,
    background: AppTheme.secondaryBg + '0% 0% no-repeat padding-box',
    border: '3px solid' + AppTheme.borderColor,
    borderRadius: 10,
    zIndex: 0,
    '@media (max-width: 767px)': {
      width: 25,
      height: 25,
    }
  },
  checkedIcon: {
    fontSize: 34,
    fontWeight: 'bold',
    color: AppTheme.selectedColor,
    zIndex: 1,
    lineHeight: .7,
    '@media (max-width: 767px)': {
      fontSize: 29,
    }
  },
  tableCell: {
    textAlign: 'center'
  }
})


// WEBPACK FOOTER //
// ./src/components/quizzing/TableNum/TableNumComponentMulti.js